import React from 'react';
import { Background } from './SimpleLoader.styled';
import { AssetAddiLogoSvgUrl } from '@addi/foundation/dist/web/assets';
export const SimpleLoader = () => React.createElement(Background, null,
    React.createElement("img", { src: AssetAddiLogoSvgUrl }));
//# sourceMappingURL=SimpleLoader.js.map